var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282 5109 c-45 -13 -109 -80 -122 -127 -7 -28 -9 -773 -8 -2443 l3 -2404 24 -38 c13 -21 42 -50 64 -65 l41 -27 1696 0 1696 0 41 27 c22 15 51 44 64 65 l24 38 0 445 0 445 -24 38 c-13 21 -42 50 -64 65 -34 23 -52 27 -107 27 -55 0 -73 -4 -107 -27 -22 -15 -51 -44 -64 -65 -24 -38 -24 -42 -27 -350 l-3 -313 -1430 0 -1429 0 0 2160 0 2160 1429 0 1430 0 3 -312 c3 -309 3 -313 27 -351 13 -21 42 -50 64 -65 34 -23 52 -27 107 -27 55 0 73 4 107 27 22 15 51 44 64 65 l24 38 0 446 0 445 -27 41 c-15 22 -44 51 -65 64 l-38 24 -1680 2 c-1042 1 -1692 -2 -1713 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4205 3296 c-5 -3 -22 -7 -37 -10 -35 -8 -94 -59 -115 -100 -22 -43 -22 -132 1 -176 10 -19 66 -83 124 -142 l105 -108 -859 -2 -859 -3 -42 -29 c-49 -33 -93 -111 -93 -166 0 -55 44 -133 93 -166 l42 -29 859 -3 859 -2 -105 -108 c-123 -125 -142 -156 -142 -232 1 -79 41 -143 114 -180 45 -24 130 -18 180 12 25 14 174 156 331 315 414 416 414 371 -9 796 -152 153 -295 289 -317 302 -38 23 -108 39 -130 31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/check-out.78c3e1ef6f27d93a7b97256d2767e153.svg";
export { ForwardRef as ReactComponent };